import React from 'react';
import { Link } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { SyncIndicator } from './SyncIndicator';
import { useT } from '../lib/i18n';
import { useData } from '../contexts/DataContext';
import { Pencil } from 'lucide-react';

export function Layout({ children, title, rightAction }) {
  const { t } = useT();
  const { profile } = useData() || {};
  const company = profile?.company_name?.trim();
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-xl border-b border-gray-100 pt-safe">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-2 min-w-0">
            {company && profile?.logo_url ? (
              <div className="w-9 h-9 rounded-xl bg-[#FAF7F2] border border-[#E5DCC9] overflow-hidden flex items-center justify-center shrink-0">
                <img src={profile.logo_url} alt="" className="w-full h-full object-contain" />
              </div>
            ) : (
              <div className="w-9 h-9 rounded-xl bg-[#7A1F2B] text-white flex items-center justify-center shrink-0">
                <Pencil size={18} strokeWidth={2.4} />
              </div>
            )}
            <div className="leading-tight min-w-0">
              <div className="font-heading font-black text-base truncate" data-testid="header-company">
                {company || t('app.name')}
              </div>
              <div className="text-[10px] uppercase tracking-widest text-gray-500 font-bold truncate">
                {company ? t('app.name') : (title || t('app.tagline'))}
                {company && title ? ` · ${title}` : ''}
              </div>
            </div>
          </Link>
          <div className="flex items-center gap-2 shrink-0">
            {rightAction}
            <SyncIndicator />
          </div>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 sm:px-6 pt-6 pb-32">{children}</main>
      <BottomNav />
    </div>
  );
}
